var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.ready && _vm.mode === 'app')?_c('home'):(_vm.$root.ready && _vm.mode === 'print' && _vm.$root.isAdmin)?_c('print'):(_vm.$root.userId === false)?_c('sign-up-in'):_c('v-app',[_c('v-overlay',{attrs:{"value":true,"opacity":"0"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"50"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }